// components/QuizQuestions.js
const QuizQuestions = ({
  questions,
  currentQuestion,
  selectedAnswer,
  onAnswerSelect,
  onNext,
  onPrevious,
  onSubmit,
  isLastQuestion
}) => {
  const currentQ = questions[currentQuestion];

  return (
    <div className="question-container">
      <div className="question-header">
        <h3>Question {currentQuestion + 1}</h3>
        <div className="question-progress">
          {currentQuestion + 1} / {questions.length}
        </div>
      </div>

      <div className="question-content">
        <p className="question-text">{currentQ.question}</p>
        
        <div className="options-container">
          {currentQ.options.map((option, index) => (
            <div
              key={index}
              className={`option ${
                selectedAnswer === index ? 'selected' : ''
              }`}
              onClick={() => onAnswerSelect(index)}
            >
              <span className="option-marker">
                {String.fromCharCode(65 + index)}
              </span>
              <span className="option-text">{option}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="navigation-buttons">
        <button
          onClick={onPrevious}
          disabled={currentQuestion === 0}
          className="btn-secondary"
        >
          Previous
        </button>
        
        {!isLastQuestion ? (
          <button onClick={onNext} className="btn-primary">
            Next
          </button>
        ) : (
          <button onClick={onSubmit} className="btn-submit">
            Submit Quiz
          </button>
        )}
      </div>
    </div>
  );
};

export default QuizQuestions;